export default "__VITE_ASSET__2htex7mG__"